import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../plots-data/plots-data.css";
import { useNavigate } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";

const HomeReservation = ({ selectedPlotData }) => {
  //   const [formData, setFormData] = useState({
  //     name: "",
  //     phoneNumber: "",
  //     plotNo: "",
  //     areaSqFt: "",
  //     totalCost: "",
  //     facing: "",
  //   });

  //     const navigate = useNavigate();

  //   const [errors, setErrors] = useState({});
  //   const [submitted, setSubmitted] = useState(false);

  //   useEffect(() => {
  //     if (selectedPlotData) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         plotNo: selectedPlotData.plotNo?.toString() || "",
  //         areaSqFt: selectedPlotData.areaSqFt?.toString() || "",
  //         totalCost: selectedPlotData.totalCost?.toString() || "",
  //         facing: selectedPlotData.facing?.toString() || "",
  //       }));
  //     }
  //   }, [selectedPlotData]);

  //   const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //     if (errors[name]) {
  //       setErrors((prev) => ({ ...prev, [name]: "" }));
  //     }
  //   };

  //   const validateForm = () => {
  //     const newErrors = {};
  //     const requiredFields = [
  //       "name",
  //       "phoneNumber",
  //       "plotNo",
  //       "areaSqFt",
  //       "totalCost",
  //       "facing",
  //     ];

  //     requiredFields.forEach((field) => {
  //       if (!formData[field].trim()) {
  //         newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required`;
  //       }
  //     });

  //     if (formData.name.trim() && formData.name.length < 2) {
  //       newErrors.name = "Name must be at least 2 characters";
  //     }

  //     if (formData.phoneNumber && !/^\d{10}$/.test(formData.phoneNumber)) {
  //       newErrors.phoneNumber = "Phone number must be 10 digits";
  //     }

  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  //   };

  //   const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) {
  //     toast.error("Please fill all fields correctly.");
  //     return;
  //   }

  //   const payload = {
  //     type: "plots",
  //     project: "Ponbhoomi",
  //     sqft: formData.areaSqFt,
  //     name: formData.name,
  //     mobile: formData.phoneNumber,
  //     facing: formData.facing,
  //     plot_no: formData.plotNo,
  //     total_cost: formData.totalCost,
  //   };

  //   try {
  //     const response = await fetch("https://cms.gphomes.in/api/enquiry-form", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log("Response data:", data);
  //     toast.success("Form submitted successfully!");
  //     setSubmitted(true);
  //     setFormData({
  //       name: "",
  //       phoneNumber: "",
  //       plotNo: "",
  //       areaSqFt: "",
  //       totalCost: "",
  //       facing: "",
  //     });

  //     setTimeout(() => {
  //       navigate("/thank-you");
  //     }, 1500);
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("Failed to submit form. Please try again.");
  //   }
  // };
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    property_type: "",
    consent: true,
  });

  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showPopup, setShowPopup] = useState(true);

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error("Name is required");
      return false;
    }

    if (!formData.mobile.trim()) {
      toast.error("Phone number is required");
      return false;
    }

    if (!/^\d{10}$/.test(formData.mobile)) {
      toast.error("Enter a valid 10-digit phone number");
      return false;
    }

    if (!formData.email.trim()) {
      toast.error("Email is required");
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      toast.error("Enter a valid email address");
      return false;
    }

    if (!formData.property_type) {
      toast.error("Please select your Interest");
      return false;
    }

    return true;
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      mobile: formData.mobile.trim(),
      property_type: formData.property_type,
      source: "Ponbhoomi page",
    };

    try {
      const response = await fetch(
        "https://cms.gphomes.in/api/save-ponbhoomi-enquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok && data.Status === "Success") {
        toast.success("Form registered successfully!");

        setFormData({
          name: "",
          email: "",
          mobile: "",
          property_type: "",
          consent: true,
        });

        // Wait 2 seconds then redirect
        setTimeout(() => {
          navigate("/thank-you");
        }, 2000);
      } else {
        toast.error(data.Results || "Something went wrong!");
      }
    } catch (error) {
      console.error("Form submission failed:", error);
      toast.error("Failed to submit form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="testimonials " id="reservation-sec">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
      />
      <div
        className="background bg-img bg-fixed py-2 py-md-4"
        style={{
          backgroundImage: `url(https://www.gphomes.in/static/media/videobg.fd443234030f853fbbd0.jpg)`,
        }}
        data-overlay-dark="3"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5 mb-30 mt-30">
              <h1 className="mb-0">Contact Us</h1>
              <br />
              <h6>
                Interested in learning more? Our property experts are here to
                help! Reach out to us, and we'll get back to you with all the
                details soon.
              </h6>
              <div className="reservations ">
                {/* <div className="icon">
                  <span className="flaticon-call"></span>
                </div> */}
                <div className="text d-flex gap-2 align-items-center justify-content-center">
                  {/* <p color-1>To Call</p> */}
                  <FaPhoneAlt
                    style={{ fontSize: "25px", color: "white" }}
                  />{" "}
                  <a className="color-1" href="tel:+919344481444">
                    9344481444
                  </a>{" "}
                  <span className="text-white fs-4 mb-2">|</span>
                  <a className="color-1" href="tel:+916384003003">
                    6384003003
                  </a>
                </div>
              </div>

              {/* <div className="reservations mb-30">
                <div className="icon">
                  <span className="flaticon-call"></span>
                </div>
                <div className="text">
                  <p color-1>Contact Us</p>
                  <a className="color-1" href="tel:+916384003003">
                    6384003003
                  </a>
                </div>
              </div> */}
            </div>

            <div className="col-md-4 offset-md-2">
              <div className="booking-box">
                <div className="head-box">
                  <h6>Enquiry Form</h6>
                  <h5 className="text-dark fs-5">
                    Drop in a line with your details.
                  </h5>
                </div>
                <div className="booking-inner clearfix">
                  <form onSubmit={handleSubmit} className="contact-form">
                    <div className="form-group">
                      <label className="ms-1" htmlFor="name">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control bg-white mb-0"
                        placeholder="Name"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label className="ms-1" htmlFor="phone">
                        Phone<span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control bg-white"
                        placeholder="Phone"
                        value={formData.mobile}
                        maxLength={10}
                        minLength={10}
                        onChange={(e) =>
                          setFormData({ ...formData, mobile: e.target.value })
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label className="ms-1" htmlFor="email">Email{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control bg-white mb-0"
                        placeholder="Email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label className="ms-1" htmlFor="property_type">
                        What are you interested in?{" "}
                        <span className="text-danger">*</span>
                      </label>

                      <div className="select-wrapper">
                        <select
                          id="property_type"
                          name="property_type"
                          className="form-control bg-white custom-select py-0"
                          value={formData.property_type}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              property_type: e.target.value,
                            })
                          }
                          style={{ height: "50px" }}
                        >
                          <option value="">Select an option</option>
                          <option value="Villas">Villas</option>
                          <option value="Villa Plots">Villa Plots</option>
                        </select>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="submit-btn mt-3"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "SUBMIT"}
                    </button>

                    {showConfirmation && (
                      <p className="text-success mt-2">
                        Form submitted successfully!
                      </p>
                    )}
                  </form>
                  {/* <form onSubmit={handleSubmit} className="form1 clearfix">
                    <div className="row">
                      {[
                        { label: "Name", name: "name", type: "text" },
                        {
                          label: "Phone Number",
                          name: "phoneNumber",
                          type: "text",
                        },
                        { label: "Plot No", name: "plotNo", type: "text" },
                        { label: "Area SqFt", name: "areaSqFt", type: "text" },
                        {
                          label: "Total Cost",
                          name: "totalCost",
                          type: "text",
                        },
                        { label: "Facing", name: "facing", type: "text" },
                      ].map(({ label, name, type }) => (
                        <div className="col-md-12" key={name}>
                          <div className="input1_wrapper">
                            <label>{label} *</label>
                            <div className="input1_inner">
                              <input
                                type={type}
                                className={`form-control ${
                                  errors[name] ? "is-invalid" : ""
                                }`}
                                
                                name={name}
                                value={formData[name]}
                                onChange={handleChange}
                                readOnly={
                                  !!selectedPlotData &&
                                  [
                                    "plotNo",
                                    "areaSqFt",
                                    "totalCost",
                                    "facing",
                                  ].includes(name)
                                }
                              />
                              {errors[name] && (
                                <div className="invalid-feedback">
                                  {errors[name]}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="col-md-12">
                        <button
                          type="submit"
                          className="btn-form1-submit mt-15"
                          disabled={submitted}
                        >
                          {submitted ? "THANK YOU!" : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeReservation;
